import { ConnectDragPreview, ConnectDragSource, useDrag } from 'react-dnd';
import { useDispatch } from 'react-redux';
import { ARTBOARD_CELL_ACCEPTED_DROP_TYPE } from 'components/ArtboardCell/useArtboardCellDropTarget';
import { EntityType } from 'const';
import { toggleDragState } from 'containers/App/actions';

type SSIActionsDragSourceHook = {
  dragRef: ConnectDragSource;
  preview: ConnectDragPreview;
};
export const useSSIActionsDragSource = (): SSIActionsDragSourceHook => {
  const dispatch = useDispatch();

  const dragSourceType = ARTBOARD_CELL_ACCEPTED_DROP_TYPE;
  const componentType = EntityType.ANCHOR;

  const [, dragRef, preview] = useDrag({
    type: dragSourceType,
    item: () => {
      dispatch(toggleDragState(dragSourceType, componentType));

      return {
        type: componentType,
      };
    },
    end: () => {
      dispatch(toggleDragState());
    },

  });

  return { dragRef, preview };
};
